import {
  Amperage,
  DeviceType,
  InlineMeterIem2055,
  InlineMeterIem2155,
  ModbusAddresses45AmpMeter,
  ModbusAddresses63AmpMeter,
} from '../../../../shared/api-clients/_api';

export type InlineMeterDevice = InlineMeterIem2055 | InlineMeterIem2155;

export const inlineMeterTypes = [DeviceType.IEM2055, DeviceType.IEM2155];

export const amperageToMeterTypeMap = {
  [Amperage.inlineMeter45amp]: DeviceType.IEM2055 as const,
  [Amperage.inlineMeter63amp]: DeviceType.IEM2155 as const,
};

export const meterTypeToModbusAddresses = {
  [DeviceType.IEM2055]: ModbusAddresses45AmpMeter,
  [DeviceType.IEM2155]: ModbusAddresses63AmpMeter,
};
